import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import { Button, Form, Input, Spin } from "antd";
import { appMessage } from "../../hooks/useAppMessage";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ForgotPasswordAPI } from "../../API/ForgotPasswordAPI";

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not valid!",
  },
};
const OTPRegex = /^[0-9]{6}$/;

export default function VerifyOtpPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(59);
  const [loadingStatus, setLoadingStatus] = useState(false);

  async function verifyOtpAPIFun(bodydata) {
    setLoadingState(true);
    await ForgotPasswordAPI.postVerifyOTP(bodydata)
      .then((res) => {
        if (res.status === true) {
          localStorage.setItem("otpKey", res.verification_key);
          navigate("/forgot-password/change-password");
        } else {
          appMessage.error(res?.message, 8);
        }
      })
      .catch(() => appMessage.error("Internal Server Error", 8))
      .finally(() => setLoadingState(false));
  }

  const verifyOtpFun = (values) => {
    const bodyData = {
      email: values.email.trim(),
      otp: values.otp,
    };
    verifyOtpAPIFun(bodyData);
  };

  async function resendeOtp() {
    setLoadingStatus(true);
    const bodydata = {
      email: localStorage.getItem("forgotEmail"),
    };
    await ForgotPasswordAPI.getForgotOTP(bodydata)
      .then((res) => {
        if (res.status === true) {
          appMessage.success("An OTP has been sent to your email address", 6);
          setMinutes(1);
          setSeconds(59);
        } else {
          appMessage.error(res?.message, 8);
        }
      })
      .catch(() => appMessage.error("Internal Server Error"))
      .finally(() => setLoadingStatus(false));
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("forgotEmail")) {
      navigate("/forgot-password");
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const handleEmailChange = (e) => {
    const trimmedValue = e.target.value.trim();
    form.setFieldsValue({ email: trimmedValue });
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        background: "#fff",
      }}
    >
      <Helmet>
        <title>SpecOptimizer</title>
      </Helmet>
      <div
        style={{
          overflow: "hidden",
          background: "linear-gradient(180deg, #D3E4FF 0%, #FFFFFF 100%)",
          height: "100%",
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <div className="reset_password_wraper">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              width: "60%",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={logo}
                style={{ marginBottom: "40px", width: "200px" }}
                alt={`img_${logo}`}
              />
              <p className="reset_paragraph">
                An OTP has been sent to your email address. Please check!
              </p>
            </div>
            <Spin spinning={loadingStatus}>
              <Form
                form={form}
                name="forgot_reset_password"
                className="login-form"
                onFinish={verifyOtpFun}
                initialValues={{ email: localStorage.getItem("forgotEmail") }}
                autoComplete="off"
                layout="vertical"
                requiredMark="optional"
                validateMessages={validateMessages}
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[{ required: true, type: "email" }]}
                >
                  <Input
                    name="email"
                    size="large"
                    disabled={true}
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    onChange={handleEmailChange}
                  />
                </Form.Item>
                <Form.Item
                  name="otp"
                  label="OTP Code"
                  rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || OTPRegex.test(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("OTP is not valid"));
                      },
                    }),
                  ]}
                >
                  <Input
                    name="otp"
                    size="large"
                    controls={false}
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <div
                  style={{
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginTop: "-10px",
                  }}
                >
                  {seconds > 0 || minutes > 0 ? (
                    <p>
                      Resend OTP in {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ) : (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        resendeOtp();
                      }}
                    >
                      Resend OTP
                    </a>
                  )}
                </div>

                <Form.Item style={{}}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{ width: "100%", marginTop: "20px" }}
                    loading={loadingState}
                  >
                    Verify
                  </Button>
                </Form.Item>
              </Form>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
}
